import { ApiCostsDataResponse, ApiProductivityResponse, ApiResponse } from '../types/api';

export class ApiService {
  private baseUrl = `${process.env.REACT_APP_S10_MEETING_API}api`;
  private headers = {
      'Token': '',
      'ModuleId': '',
      'Content-Type': 'application/json'
  };

  setAuth(token: string, moduleId: string) {
    this.headers.ModuleId = moduleId;
    this.headers.Token = token.replaceAll(' ', '+');
  }

  async getMeteredData(
    currentLoggedInPersonId: number,
    activityId: number,
    onlyRelevantData: boolean = true,
    isRestrictionProject: boolean = false
  ): Promise<ApiResponse> {
    const params = new URLSearchParams({
      CurrentLoggedInPersonId: currentLoggedInPersonId.toString(),
      activityid: activityId.toString(),
      onlyRelevantData: onlyRelevantData.toString(),
      isRestrictionProject: isRestrictionProject.toString()
    });
    const response = await fetch(
      `${this.baseUrl}/Card/GetMeteredByPeriod?${params}`,
      {headers: this.headers}
    ).catch(e => {
        console.error('request error', e)
        return e
    });
    const body = await response?.json();
    console.log('body', body)
    if (response.status !== 200) {
      throw new Error(body.Message || `API Error: ${response.status}`);
    }
    return body
  }

  async getProductivityData(
    activityId: number,
  ): Promise<ApiProductivityResponse> {
    const params = new URLSearchParams({
      Id: activityId.toString(),
    });
    const response = await fetch(
      `${this.baseUrl}/GanttTask/ToListProductivityByTaskWeek?${params}`,
      {headers: this.headers}
    ).catch(e => {
        console.error('request error', e)
        return e
    });
    const body = await response?.json();
    console.log('body', body)
    if (response.status !== 200) {
      throw new Error(body.Message || `API Error: ${response.status}`);
    }
    return body[0]
  }

  async getProductivityByDaysData(
    activityId: number,
  ): Promise<ApiProductivityResponse> {
    const params = new URLSearchParams({
      Id: activityId.toString(),
    });
    const response = await fetch(
      `${this.baseUrl}/GanttTask/ToListProductivityByTaskDaily?${params}`,
      {headers: this.headers}
    ).catch(e => {
        console.error('request error', e)
        return e
    });
    const body = await response?.json();
    console.log('body', body)
    if (response.status !== 200) {
      throw new Error(body.Message || `API Error: ${response.status}`);
    }
    return body[0]
  }

  async getCostsByWeekData(
    activityId: number,
    userId: number,
  ): Promise<ApiCostsDataResponse> {
    const params = new URLSearchParams({
      parentGanttTaskId: activityId.toString(),
      userId: userId.toString(),
    });
    const response = await fetch(
      `${this.baseUrl}/GanttTask/GetCostScheduleRollupById_Weekly?${params}`,
      {headers: this.headers}
    ).catch(e => {
        console.error('request error', e)
        return e
    });
    const body = await response?.json();
    console.log('body', body)
    if (response.status !== 200) {
      throw new Error(body.Message || `API Error: ${response.status}`);
    }
    return body[0]
  }

  async getCostsData(
    activityId: number,
    userId: number,
  ): Promise<ApiCostsDataResponse> {
    const params = new URLSearchParams({
      parentGanttTaskId: activityId.toString(),
      userId: userId.toString(),
    });
    const response = await fetch(
      `${this.baseUrl}/GanttTask/GetCostScheduleRollupById?${params}`,
      {headers: this.headers}
    ).catch(e => {
        console.error('request error', e)
        return e
    });
    const body = await response?.json();
    console.log('body', body)
    if (response.status !== 200) {
      throw new Error(body.Message || `API Error: ${response.status}`);
    }
    return body[0]
  }
}